<template>
  <div>
    <GMapMap :center="center" :zoom="16" style="width: 100%; height: 400px">
      <GMapMarker
        v-for="(m, i) in markers"
        :key="i"
        :position="m.position"
        :icon="{ url: $img('im-pin.png') }"
        :clickable="true"
        @click="toggleInfoWindow(m, i)"
      />
      <GMapInfoWindow
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <div>
          <b>{{ $t("contact.email") }}:</b><br />
          {{ $root.contactUsEmailRaw() }}<br /><br />
          <b>{{ $t("contact.phone") }}:</b><br />
          <a href="tel:+35982825505">+359 82 82 55 05</a><br /><br />
          <b>{{ $t("contact.address") }}:</b><br />
          {{ $t("contact.company_name") }}<br />
          {{ $t("contact.company_street") }}<br />
          {{ $t("contact.company_city") }}
        </div>
      </GMapInfoWindow>
    </GMapMap>
  </div>
</template>

<script>
  export default {
    name: "GoogleMap",
    data() {
      return {
        center: { lat: 43.840782, lng: 25.948499 },
        infoContent: "",
        infoWindowPos: {
          lat: 0,
          lng: 0,
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -90,
          },
        },
        markers: [
          {
            position: {
              lat: 43.840782,
              lng: 25.948499,
            },
          },
        ],
      };
    },
    methods: {
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.position;

        // check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        // if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
    },
  };
</script>
